/* eslint-disable @typescript-eslint/no-explicit-any */

import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client/contexts'
import { useInteraction } from '@mercadoni/sinister/dist/cjs/monitors/hooks'
import { trackEvent } from '@mercadoni/sinister/dist/cjs/monitors/services'
import styled from 'styled-components'
import LinkAtomic from '../../atomic/Link'
import Icon from './Icon'
import Text from './Text'

const StyledLink = styled(LinkAtomic)`
  display: inline-flex;
  align-items: center;
  font-weight: var(--typography-weight-bold);
  text-decoration: none;
`

const LinkLogic = ({
  Wrapper,
  href,
  target,
  icon,
  text,
  color,
}: {
  Wrapper: any
  href: string
  target: string
  icon: string
  text: string
  color: string
}) => {
  const { sendInteractionEvent } = useInteraction()
  const { clientId } = UseClientModelContext()

  const onClick = () => {
    trackEvent({
      eventName: 'help_item_link_clicked',
      href,
      text,
      source: 'desktop',
      clientId,
    })
    sendInteractionEvent({ interactionName: text })
  }

  return (
    <Wrapper href={href} target={target} onClick={onClick}>
      <Icon icon={icon} color={color} />
      <Text text={text} color={color} />
    </Wrapper>
  )
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Link = (props: any) => <LinkLogic Wrapper={StyledLink} {...props} />

export default Link
